export const IMAGE_FILE_SELECTED = 'IMAGE_FILE_SELECTED';
export const AUDIO_FILE_SELECTED = 'AUDIO_FILE_SELECTED';

export function fileFieldChanged(file, component, type) {
  const {
    onComplete,
    onProgress,
    onError,
  } = component;

  const {
    wgToken,
    placeholderType,
    validationKey,
  } = component.props;

  return {
    type,
    payload: {
      file,
      onComplete: onComplete.bind(component),
      onProgress: onProgress.bind(component),
      onError: onError.bind(component),
      wgToken,
      placeholderType,
      validationKey,
    },
  };
}



// WEBPACK FOOTER //
// ./src/actions/uploader.js